import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { TId, TechnicalFeature, TechnicalFeaturesGroups } from 'src/app/models';
import { GenericResource } from 'src/app/resources';
import { TechnicalFeaturesAddComponent } from '../components/technical-features-add/technical-features-add.component';

@Component({
    selector: 'app-products-technical-features-groups-edit',
    templateUrl: './products-technical-features-groups-edit.component.html',
    styleUrls: ['./products-technical-features-groups-edit.component.css'],
    standalone: false
})
export class ProductsTechnicalFeaturesGroupsEditComponent extends GenericCrudEditComponent<TechnicalFeaturesGroups>{

  techninalFeatures?: GenericResource<TechnicalFeature>;
  features: TechnicalFeature[] = [];
  override resource = this.api.resources.product.technicalFeatureGroups;
  displayEntity = () => this.entity!.name;
  createGroupTechnicalFeatureComponent = TechnicalFeaturesAddComponent;

  override async preFetch(): Promise<void> {
    this.features = await firstValueFrom(this.api.resources.product.technicalfeatures.getAll({companyId: this.api.auth.userValue?.lastCompanyId}));
    this.techninalFeatures = this.api.resources.product.technicalFeaturesOfGroup(this.entity!.id)
  }

  initFormGroup(): FormGroup {
    const technicalFeaturegroup: TechnicalFeaturesGroups = this.entity!;
    const group = this.fb.group({
      id: [technicalFeaturegroup.id],
      name: [technicalFeaturegroup.name],
    });
    return group;
  }

  async onFeatureSelected(data: any, tid: TId): Promise<void> { 
    const feature = this.features.find(ft => ft.id === tid);
    data.data.technicalFeatureId = tid;
    data.data.name = feature?.name;
    data.data.code = feature?.code;
    data.setValue(tid, tid); 
  }

  setCellValue(newData: any, value : any) {
    newData.technicalFeatureId = value;
  }
}
